import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

/**
 * Хук для синхронізації мови між URL та localStorage
 * Автоматично оновлює мову в localStorage при зміні URL
 */
export const useLanguageSync = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentLanguage, changeLanguage } = useLanguage();

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const urlLanguage = pathSegments[0];
    
    // Список маршрутів, які не потребують мовного префіксу
    const noLanguagePrefixRoutes = [
      'translate-recipe',
      'support/chat'
    ];
    
    // Перевіряємо чи це маршрут без мовного префіксу
    const isNoLanguagePrefixRoute = noLanguagePrefixRoutes.some(route => 
      location.pathname.startsWith(`/${route}`)
    );
    
    // Перевіряємо чи це валідна мова
    if (urlLanguage && ['uk', 'en'].includes(urlLanguage)) {
      // Якщо мова в URL відрізняється від поточної, оновлюємо localStorage
      if (currentLanguage !== urlLanguage) {
        changeLanguage(urlLanguage);
      }
    } else if (pathSegments.length > 0 && !isNoLanguagePrefixRoute && location.pathname !== '/') {
      // Якщо URL не містить мовного префіксу і це не спеціальний маршрут
      // Додаємо поточну мову до URL
      const newPath = `/${currentLanguage}${location.pathname}${location.search}`;
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, location.search, currentLanguage, changeLanguage, navigate]);

  return { currentLanguage };
};

export default useLanguageSync;